import { render } from "./RadioBox.vue?vue&type=template&id=fd2dc9a6&scoped=true"
import script from "./RadioBox.vue?vue&type=script&lang=js"
export * from "./RadioBox.vue?vue&type=script&lang=js"

import "./RadioBox.vue?vue&type=style&index=0&id=fd2dc9a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd2dc9a6"

export default script